var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-lock-ratio"},[_c('figure',{staticClass:"image-lock-ratio__container",style:(_vm.style)},[_c('img',{staticClass:"image-lock-ratio__content",style:({ objectFit: _vm.cover ? 'cover' : undefined }),attrs:{"src":_vm.currentSrc,"alt":_vm.alt},on:{"error":_vm.setFallback}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }